import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { TwoFactorAuthenticationService } from '../../service/two-factor-authentication.service';
@Component({
  selector: 'app-configuration',
  standalone: true,
  templateUrl: './configuration.component.html',
  styleUrls: ['./configuration.component.scss'],
  imports: [ButtonModule],
})
export class ConfigurationComponent {
  constructor(
    public ref: DynamicDialogRef,
    private twoFactorAuthenticationService: TwoFactorAuthenticationService
  ) {}

  onConfigure() {
    this.ref.close(true);
    this.twoFactorAuthenticationService.openReAuthenticationDialog('enroll');
  }
}
